import { useEffect, useState } from "react";
import "./AdminNewsletters.css";
import CdnEditor from "../../app/components/CkEditorCustom/CdnEditor";
import { toast } from "react-toastify";
import { Route, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import { blogPostStatus } from "../../app/Enums/StatusEnums";
import DOMPurify from "dompurify";
import { insertNewsletters } from "../../api/newsletterApi/newsletter";
import uploadSvg from "../../assets/icons/upload.svg";
import Feedback from "../../app/components/FeedbackModal/Feedback";
import { routePath } from "../../app/routes/routepath";
export default function CreateAdminNewsletter() {
  const navigate = useNavigate();
  const [id, setAuthorId] = useState(0);
  const [isProcessing, setisProcessing] = useState(null);
  const [finalData, setFinalData] = useState({
    newsletterTitle: "",
    newsletterDescription: "",
    newsletterContent: "",
    newsletterCoverImage: "",
  });

  const handleResetForm = () => {
    setFinalData({
      newsletterTitle: "",
      newsletterDescription: "",
      newsletterContent: "",
      newsletterCoverImage: "",
    });
  };

  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [submitResponse, setSubmitResponse] = useState(true);
  const [feedback, setFeedback] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  //used to load the token
  useEffect(() => {
    if (localStorage.getItem("token") != null) {
      const id = parseInt(localStorage.getItem("UserId"));
      setAuthorId(id);
      setFinalData((prev) => ({
        ...prev,
        authorId: id,
      }));
    } else {
      toast.error("please login to post Newsletter");
      navigate("/home");
    }
  }, []);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  };
  const validateForm = () => {
    if (
      !finalData.newsletterTitle.trim() ||
      !finalData.newsletterContent.trim() ||
      !finalData.newsletterDescription.trim() ||
      !finalData.newsletterCoverImage
    ) {
      toast.error("Please fill all the required fields.");
      return false;
    }
    return true;
  };
  const sanitizeInputs = () => {
    const cleanHTML = DOMPurify.sanitize(finalData.newsletterContent, {
      FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
      FORBID_TAGS: ["iframe", "object", "embed"],
    });
    return {
      ...finalData,
      newsletterTitle: DOMPurify.sanitize(finalData.newsletterTitle),
      newsletterDescription: DOMPurify.sanitize(
        finalData.newsletterDescription,
      ),
      newsletterContent: cleanHTML,
      newsletterCoverImage: finalData.newsletterCoverImage,
      authorId: finalData.authorId,
    };
  };

  //functions
  const handleTitleChange = (e) => {
    const value = e.target.value;
    setFinalData((prev) => ({
      ...prev,
      newsletterTitle: value,
    }));
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setFinalData((prev) => ({ ...prev, newsletterDescription: value }));
  };

  const handleContentChange = (value) => {
    setFinalData((prev) => ({ ...prev, newsletterContent: value }));
  };

  const handleCoverImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const maxSize = 20 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error("Image size cannot exceed 20 MB");
      e.target.value = ""; // optional: clear input
      return;
    }
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);
      const base64 = await convertToBase64(compressedFile);
      setFinalData((prev) => ({ ...prev, newsletterCoverImage: base64 }));
    } catch (error) {
      console.error("Compression and conversion error", error);
    }
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    const authorId = parseInt(localStorage.getItem("UserId"));
    /*         const roleId = parseInt(localStorage.getItem("RoleId")); */

    const updatedData = {
      ...sanitizeInputs(),
      actionType: blogPostStatus.submit,
      authorId,
      /*   roleId, */
    };
    console.log(updatedData);
    setisProcessing("Publish Newsletter");
    try {
      const res = await insertNewsletters(updatedData);
      if (!res.error && res.data?.result_value === true) {
        setSubmitResponse(true);
        setFeedback({
          open: true,
          type: "success",
          title: "Newsletter Created",
          message: "Your newsletter has been created successfully. ",
        });
        handleResetForm();
      } else {
        setSubmitResponse(false);
        setFeedback({
          open: true,
          type: "error",
          title: "Failed",
          message: "Something went wrong. Please try again.",
        });

        // setIsModalOpen1(true);
      }
    } catch (error) {
      console.log("Post request failed", error);
      setSubmitResponse(false);
      setFeedback({
        open: true,
        type: "error",
        title: "Failed",
        message: "Something went wrong. Please try again.",
      });
    } finally {
      setisProcessing(null);
    }
  };

  const getCharacterCount = (html = "") => {
    const doc = new DOMParser().parseFromString(html || "", "text/html");
    return doc.body.textContent?.length || 0;
  };

  const handleBack = () => navigate("/adminNewsletter");

  return (
    <>
      <div className="role-box">
        <ul className="breadcumb">
          <li className="active" onClick={handleBack}>
            <i className="bi bi-file-earmark-richtext"></i>
            Newsletter
          </li>

          <li className="dash-arrow">/</li>

          <li>
            <span>Add Newsletter</span>
          </li>
        </ul>
      </div>
      <div className="newsletter_wrapper">
        <div className="main_widget">
          <div className="w-100 border-radius-6">
            <div className="blog_form_header">
              <h2>Add Your Newsletter</h2>
            </div>
            <div className="blog_form_body">
              <div className="blog_form_main_Wraper">
                <div className="form-wraper-bx">
                  <label className="label">
                    Title<sup>*</sup>
                  </label>
                  {/* <div className="input_box">
              <input
                type="text"
                value={finalData.newsletterTitle}
                placeholder="Title"
                className="form-control"
                onChange={handleTitleChange}
              />
            </div> */}
                  <div className="input_box">
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Enter newsletter title (max 80 characters)"
                        value={finalData.newsletterTitle}
                        className="form-control"
                        maxLength={80}
                        onChange={handleTitleChange}
                        style={{ paddingRight: "55px" }}
                      />

                      <span
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "12px",
                          color:
                            finalData.newsletterTitle.length >= 80
                              ? "red"
                              : "#999",
                          pointerEvents: "none",
                        }}
                      >
                        {finalData.newsletterTitle.length}/80
                      </span>
                    </div>
                  </div>
                </div>
                <div className="form-wraper-bx">
                  <label className="label">
                    Summary<sup>*</sup>
                  </label>
                  <div className="input_box">
                    <input
                      type="text"
                      value={finalData.newsletterDescription}
                      placeholder="Keywords"
                      className="form-control"
                      onChange={handleDescriptionChange}
                    />
                  </div>
                </div>
                <div className="form-wraper-bx">
                  <label className="label">
                    Content<sup>*</sup>
                  </label>
                  <div className="input_box">
                    <CdnEditor
                      value={finalData.newsletterContent}
                      toolbar={[
                        "undo",
                        "redo",
                        "|",
                        "heading",
                        "|",
                        "bold",
                        "italic",
                        "link",
                        "|",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "blockQuote",
                      ]}
                      onChange={handleContentChange}
                      className="form-control"
                    />
                    <p>
                      {getCharacterCount(finalData.newsletterContent)}{" "}
                      Characters
                    </p>
                  </div>
                </div>
                <div className="form-wraper-bx">
                  <label className="label">
                    Upload Cover Image<sup>*</sup>
                  </label>
                  <div className="upload-container">
                    <img src={uploadSvg} alt="Upload" />
                    <h2>Upload Your File</h2>
                    <label htmlFor="file-upload" className="custom-file-upload">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M12 16v-8M8 12l4-4 4 4M4 20h16"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Choose File
                    </label>
                    <p class="limit-text">Maximum upload size 20 MB</p>
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleCoverImageChange}
                    />
                    <div>
                      {finalData.newsletterCoverImage && (
                        <img
                          src={finalData.newsletterCoverImage}
                          style={{
                            width: 300,
                            height: 150,
                            borderRadius: 10,
                            marginTop: "20px",
                          }}
                          alt="newsletter Cover"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="blog_form_btn_wraper">
                  <button
                    className="delete_approve_btn"
                    onClick={handleSubmit}
                    disabled={isProcessing === "Publish Newsletter"}
                  >
                    {isProcessing === "Publish Newsletter" ? (
                      <div className="Publish_spinner"></div>
                    ) : (
                      "Publish Newsletter"
                    )}
                  </button>
                  <button
                    className="delete_reject_btn"
                    onClick={handleResetForm}
                  >
                    Reset Values
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {isModalOpen1 && (
        <div className="modal-overlay">
          <div className="succes-modal">
            <div className="success-circle">&#10004;</div>
            <h2>{submitResponse ? "Success" : "Failed"}</h2>
            <p>
              {submitResponse
                ? "Your newsletter has been submitted for review."
                : "Something went wrong. Please try again."}
            </p>
            <div className="sucess-modal-wraper">
              <button
                onClick={() => setIsModalOpen1(false)}
                className="primary_btn"
              >
                OK
              </button>
              {navigate("/adminNewsletter")}
            </div>
          </div>
        </div>
      )} */}
      </div>

      <Feedback
        isOpen={feedback.open}
        type={feedback.type}
        title={feedback.title}
        message={feedback.message}
        onClose={() => {
          setFeedback({ ...feedback, open: false });
          navigate(routePath.adminNewsletter);
        }}
      />
    </>
  );
}
